import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider, DefaultTheme } from 'styled-components';
import { RootState } from '../../redux/store';
import { LoadingSpinnerProps } from './types';
import { LOADING_SPINNER_CONSTANTS } from './constants';
import { SpinnerContainer, StyledSpin, LoadingText } from './styles';

const LoadingSpinner = forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  (
    {
      size = LOADING_SPINNER_CONSTANTS.DEFAULT_SIZE,
      text = LOADING_SPINNER_CONSTANTS.DEFAULT_TEXT,
      padding,
      py,
      showText = LOADING_SPINNER_CONSTANTS.DEFAULT_SHOW_TEXT,
      fullScreen = LOADING_SPINNER_CONSTANTS.DEFAULT_FULL_SCREEN,
      className,
    },
    ref
  ) => {
    const { isDarkMode } = useSelector((state: RootState) => state.theme);

    const theme: DefaultTheme = {
      mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark',
    };

    const mappedSize: 'small' | 'default' | 'large' =
      size === 'md' ? 'default' : size === 'xl' ? 'large' : (size as 'small' | 'default' | 'large');

    const finalPadding = py !== undefined ? py : padding !== undefined ? padding : LOADING_SPINNER_CONSTANTS.DEFAULT_PADDING;

    return (
      <ThemeProvider theme={theme}>
        <SpinnerContainer
          ref={ref}
          $fullScreen={fullScreen}
          $padding={finalPadding}
          className={className}
        >
          <StyledSpin size={mappedSize} />
          {showText && text && <LoadingText $isDarkMode={isDarkMode}>{text}</LoadingText>}
        </SpinnerContainer>
      </ThemeProvider>
    );
  }
);

LoadingSpinner.displayName = 'LoadingSpinner';

export default React.memo(LoadingSpinner);
